import {Component} from '@angular/core';
import {AppConfigService} from '../../common/service/app-config.service';

@Component({
    selector: 'nlr-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    constructor(private appConfigService: AppConfigService) {}

    releaseVersion(): string {
        return this.appConfigService.getReleaseVersion();
    }
}
